import { gql } from 'graphql-tag'
import fragmentPageKnowledgeHubDetail from '#layers/core/data-layer/pages/page-knowledge-hub-detail/fragment-page-knowledge-hub-detail'

// use the definition from data-layer/definitions/knowledgeHub.js ??
// change the customArticles query to get not only the ones that have articleType but also industries, products and topics

/**
 query ($locale: String!, $limit: Int!, $customTagId: String!) {
 customArticles: pageKnowledgeHubDetailCollection (
 order: date_DESC,
 limit: $limit,
 locale: $locale,
 where: {
 OR: [
 { productsTagged_contains: $customTagId },
 { industriesTagged_contains: $customTagId },
 { topicsTagged_contains: $customTagId },
 { articleType: { sys: { id: $customTagId } }}
 ]
 }
 ) {
 items {
 ...PageKnowledgeHubDetailFragment
 }
 }
 }
 */

export const queryPageKnowledgeHubSupplementaryData = gql`
  ${fragmentPageKnowledgeHubDetail}
  query ($locale: String!, $limit: Int!, $articleTypeId: String!, $customTagId: String!, $preview: Boolean!) {
    latestArticles: pageKnowledgeHubDetailCollection(
      order: date_DESC
      limit: $limit
      locale: $locale
      preview: $preview
      where: { slug_exists: true, visibleInKnowledgeHub_not: false }
    ) {
      items {
        ...PageKnowledgeHubDetailFragment
      }
    }
    fixedTypeArticles: pageKnowledgeHubDetailCollection(
      order: date_DESC
      limit: $limit
      locale: $locale
      preview: $preview
      where: { slug_exists: true, visibleInKnowledgeHub_not: false, articleType: { sys: { id: $articleTypeId } } }
    ) {
      items {
        ...PageKnowledgeHubDetailFragment
      }
    }
    customArticles: pageKnowledgeHubDetailCollection(
      order: date_DESC
      limit: $limit
      locale: $locale
      preview: $preview
      where: {
        slug_exists: true
        visibleInKnowledgeHub_not: false
        AND: [
          {
            OR: [
              { products: { sys: { id: $customTagId } } }
              { industries: { sys: { id: $customTagId } } }
              { topics: { sys: { id: $customTagId } } }
              { articleType: { sys: { id: $customTagId } } }
            ]
          }
        ]
      }
    ) {
      items {
        ...PageKnowledgeHubDetailFragment
      }
    }
  }
`
